export default "__VITE_ASSET__b07a3acc__"